import type { StaticSharedField } from './types';
import {
  ERR_TYPE_REQUIRED,
  ERR_TYPE_STR_LONG,
  ERR_TYPE_STR_SHORT,
  FIELD_TYPE_TXT,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useSourceDescription(): StaticSharedField {
  return {
    propName: 'source_description',
    element: 'source_description',
    type: FIELD_TYPE_TXT,
    label: 'Source description',
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOSOURCEDESCRIPTION',
        errStr: 'Please enter a source description',
      },
      {
        rule: ERR_TYPE_STR_SHORT,
        errCode: 'ERRSOURCEDESCRIPTIONTOOSHORT',
        errStr: 'Source description too short',
        value: 3,
      },
      {
        rule: ERR_TYPE_STR_LONG,
        errCode: 'ERRSOURCEDESCRIPTIONTOOLONG',
        errStr: 'Source description too long',
        value: 300,
      },
    ],
  };
}
